import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  // BehaviorSubjects to store filter state
  private filterStateSubject = new BehaviorSubject<{ 
    startDate: Date | null; 
    endDate: Date | null; 
    status: string | "All";
    dayMsg:string |  "(Last 24 Hours)";
  }>({
    startDate: null,
    endDate: null,
    status: "All",
    dayMsg:  "(Last 24 Hours)"
  });

  private userSubject=new BehaviorSubject<any>(null);
  private venueSubject=new BehaviorSubject<{ 
    startDate: Date | null; 
    endDate: Date | null; 
    restId:string | "All";
  }>({
    startDate: null,
    endDate: null,
    restId:"All"
  });

  // Observable for components to subscribe to
  public filterState$ = this.filterStateSubject.asObservable();
  public user$ = this.userSubject.asObservable();
  public venueTransaction$ = this.venueSubject.asObservable();


  setUser(user:any){
    this.userSubject.next(user);
  }
  getUser():any{
   return this.userSubject.value;
  }
  // Method to update filter state
  setFilterState(startDate: Date | null, endDate: Date | null, status: string | "",  dayMsg:string|""): void {
    this.filterStateSubject.next({ startDate, endDate, status,dayMsg });
  }

  // Method to get the current filter state
  getFilterState(): { startDate: Date | null; endDate: Date | null; status: string | "",dayMsg:string|"" } {
    return this.filterStateSubject.value;
  }
  clearFilterState(){
    this.setFilterState(null,null,"All","(Last 24 Hours)");
  }

  // venue Transaction filter
  setVenueFilter(startDate: Date | null, endDate: Date|null,restId: string|"All"): void {
    this.venueSubject.next({ startDate, endDate ,restId});
  }
  getVenueFilter(): { startDate: Date | null; endDate: Date | null;restId:string|"All"} {
    return this.venueSubject.value;
  }
  clearDateFilter(){
    const currentFilter = this.getVenueFilter(); // Get the current filter values
    this.setVenueFilter(null,null,currentFilter.restId);
  }
  clearRestFilter(){
    const currentFilter = this.getVenueFilter(); // Get the current filter values
    this.setVenueFilter(currentFilter.startDate,currentFilter.endDate,"All")
  }
  constructor() { }
}

